import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { HierarchyNode } from "d3-hierarchy";
import { Session } from "@webapp/sessions/models/sessions.model";

@Component({
  selector: "single-goal-selector-session-tree",
  templateUrl: "./session-tree.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleGoalSelectorSessionTreeComponent {
  @Input() public session: HierarchyNode<Session>;

  @Output()
  public readonly sessionSelected = new EventEmitter();

  public selectSessionFromList(selectedSession: Session): void {
    this.sessionSelected.emit(selectedSession);
  }
}
